import React from 'react';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-145">
      <div className="max-w-3xl mx-auto prose prose-lg prose-purple" data-id="element-146">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 font-heading leading-tight" data-id="element-147">
          ¿Te sientes inflamada, cansada y frustrada porque "nada funciona"?
        </h2>

        <div className="bg-red-50 border-l-4 border-red-400 p-6 mb-10 rounded-r-lg" data-id="element-148">
          <p className="text-red-800 font-medium m-0 italic" data-id="element-149">
            Descubre por qué tu cuerpo en USA está atrapado en el 'Modo
            Supervivencia' y cómo liberarlo en 15 minutos al día.
          </p>
        </div>

        <p className="text-gray-700 mb-6" data-id="element-150">
          <span className="font-bold text-gray-900" data-id="element-151">Querida amiga,</span>
        </p>

        <p className="text-gray-700 mb-6" data-id="element-152">
          Si vives en Estados Unidos, sabes lo que es el verdadero estrés. Las
          jornadas largas, las cuentas, la familia y esa sensación de que el
          tiempo nunca alcanza.
        </p>

        <p className="text-gray-700 mb-6" data-id="element-153">
          Pero hay algo que quizás no notas... hasta que te miras al espejo.
        </p>

        <ul className="space-y-4 mb-8 list-none pl-0" data-id="element-154">
          <li className="flex items-start" data-id="element-155">
            <span className="text-red-500 mr-3 text-xl" data-id="element-156">✖</span>
            <span className="text-gray-700" data-id="element-157">
              Esa inflamación persistente en el abdomen que parece no irse con
              nada.
            </span>
          </li>
          <li className="flex items-start" data-id="element-158">
            <span className="text-red-500 mr-3 text-xl" data-id="element-159">✖</span>
            <span className="text-gray-700" data-id="element-160">
              Ese cansancio que no se cura ni con 3 cafés al día.
            </span>
          </li>
          <li className="flex items-start" data-id="element-161">
            <span className="text-red-500 mr-3 text-xl" data-id="element-162">✖</span>
            <span className="text-gray-700" data-id="element-163">
              Esa sensación de que tu metabolismo "se apagó" al cumplir los 35 o
              40 años.
            </span>
          </li>
        </ul>

        <h3 className="text-2xl font-bold text-gray-900 mt-12 mb-6 font-heading" data-id="element-164">
          La verdad que nadie te dice es esta:{' '}
          <span className="bg-yellow-100 px-1" data-id="element-165">
            No estás gorda. Estás inflamada por el cortisol.
          </span>
        </h3>

        <p className="text-gray-700 mb-6" data-id="element-166">
          En este país, vivimos bajo un ataque constante a nuestro sistema
          nervioso. El estrés eleva el cortisol, y el cortisol le da una orden
          clara a tu cuerpo:
        </p>

        <blockquote className="border-l-4 border-purple-500 pl-6 py-2 my-8 bg-purple-50 rounded-r-lg" data-id="element-167">
          <p className="text-xl font-serif italic text-purple-900 m-0" data-id="element-168">
            "Guarda toda la grasa posible en el abdomen, porque estamos en
            peligro".
          </p>
        </blockquote>

        <p className="text-gray-700 mb-6" data-id="element-169">
          Al intentar hacer dietas extremas o cardio matador, solo le confirmas
          a tu cuerpo que el peligro es real. Por eso, entre más te esfuerzas,
          más se resiste tu abdomen.
        </p>
      </div>
    </section>;
}